export default "__VITE_ASSET__DhO1UvQd__"